// deps
import React, { memo } from "react";

// internal deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { isEmpty } from "@swiggy-private/js-utils";
import DiscountMessage from "./DiscountMessage";

// constants
import { TURBO_WALLET_BALANCE_TEXT } from "@payment-ui/constants/TurboPayment";
import { TurboPaymentVariant } from "@payment-ui/interfaces";
import { isQuickCheckoutVariant } from "@payment-ui/helpers/TurboPayment";

// styles
import { BalanceContentWrapper, BalanceValueContainer, Container } from "./styles";

interface ITurboPaymentDisplayNameProps {
    promoMsg?: string;
    newLineBalanceMeta?: {
        show: boolean;
        value?: string | number;
    };
    discount?: string;
    variant?: TurboPaymentVariant;
}

function TurboPaymentMethodMetaWidget(props: ITurboPaymentDisplayNameProps) {
    const { newLineBalanceMeta, discount, promoMsg, variant = TurboPaymentVariant.DEFAULT } = props;
    const isQuickCheckout = isQuickCheckoutVariant(variant);
    return (
        <Container>
            {newLineBalanceMeta?.show && !isEmpty(newLineBalanceMeta.value) && (
                <BalanceContentWrapper>
                    <Text variant="V2.body3.neutral.regular" color="text_High_Emphasis">
                        {TURBO_WALLET_BALANCE_TEXT}
                    </Text>
                    <Text variant="V2.body3.neutral.regular" color="text_High_Emphasis">
                        <BalanceValueContainer>{String(newLineBalanceMeta.value)}</BalanceValueContainer>
                    </Text>
                </BalanceContentWrapper>
            )}
            <DiscountMessage discount={discount} isQuickCheckout={isQuickCheckout} />
            {promoMsg && promoMsg.length > 0 && (
                <Text
                    variant="V2.body3.neutral.regular"
                    color="text_Med_Emphasis"
                    maxLines={isQuickCheckout ? 1 : undefined}
                >
                    {promoMsg}
                </Text>
            )}
        </Container>
    );
}

export default memo(TurboPaymentMethodMetaWidget);
